module.exports = __webpack_public_path__ + "media/index_music_base.6080e676.mp4";